import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { ReportSimple } from './../../overrides/model/ReportSimple.js';
import { ProjectSimple } from './../../overrides/model/ProjectSimple.js';
import { UserGroup } from './../../overrides/model/UserGroup.js';
import { MediaSimple } from './../../overrides/model/MediaSimple.js';
import { UserRoleSimple } from './../../overrides/model/UserRoleSimple.js';
import { UserAbility } from './../../overrides/model/UserAbility.js';
import { LanguagePreference } from './../../overrides/model/LanguagePreference.js';
import { DashboardPreference } from './../../overrides/model/DashboardPreference.js';
import type { Constructor } from '@whispli/types';

export class __User extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  /**
   * @deprecated For backwards-compatibility only. Use firstName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  public first_name!: string;

  @Expose({groups: ['client']})
  public get firstName() {
    return this.first_name
  }

  public set firstName(value) {
    this.first_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use lastName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  public last_name!: string;

  @Expose({groups: ['client']})
  public get lastName() {
    return this.last_name
  }

  public set lastName(value) {
    this.last_name = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly email!: string;
  /**
   * @deprecated For backwards-compatibility only. Use jobTitle
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private job_title!: string | null;

  @Expose({groups: ['client']})
  public get jobTitle() {
    return this.job_title
  }

  public set jobTitle(value) {
    this.job_title = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly timezone!: string;
  /**
   * @deprecated For backwards-compatibility only. Use samlUid
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private saml_uid!: string | null;

  @Expose({groups: ['client']})
  public get samlUid() {
    return this.saml_uid
  }

  public set samlUid(value) {
    this.saml_uid = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isBillable
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_billable!: boolean;

  @Expose({groups: ['client']})
  public get isBillable() {
    return this.is_billable
  }

  public set isBillable(value) {
    this.is_billable = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isMfaEnabled
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_mfa_enabled!: boolean;

  @Expose({groups: ['client']})
  public get isMfaEnabled() {
    return this.is_mfa_enabled
  }

  public set isMfaEnabled(value) {
    this.is_mfa_enabled = value
  }

  @Type(() => ReportSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly whispers!: (ReportSimple)[];
  @Type(() => ProjectSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly projects!: (ProjectSimple)[];
  /**
   * @deprecated For backwards-compatibility only. Use userGroups
   */
  @Type(() => UserGroup)
  @Expose({groups:["server"]})
  private user_groups!: (UserGroup)[];

  @Expose({groups: ['client']})
  public get userGroups() {
    return this.user_groups
  }

  public set userGroups(value) {
    this.user_groups = value
  }

  @Type(() => MediaSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly media!: (MediaSimple)[];
  @Type(() => UserRoleSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly roles!: (UserRoleSimple)[];
  @Type(() => UserAbility)
  @Expose({ groups: ['client', 'server'] })
  public readonly abilities!: (UserAbility)[];
  /**
   * @deprecated For backwards-compatibility only. Use forbiddenAbilities
   */
  @Type(() => UserAbility)
  @Expose({groups:["server"]})
  private forbidden_abilities!: (UserAbility)[];

  @Expose({groups: ['client']})
  public get forbiddenAbilities() {
    return this.forbidden_abilities
  }

  public set forbiddenAbilities(value) {
    this.forbidden_abilities = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use languagePreferences
   */
  @Type(() => LanguagePreference)
  @Expose({groups:["server"]})
  private language_preferences!: LanguagePreference | null;

  @Expose({groups: ['client']})
  public get languagePreferences() {
    return this.language_preferences
  }

  public set languagePreferences(value) {
    this.language_preferences = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use dashboardPreferences
   */
  @Type(() => DashboardPreference)
  @Expose({groups:["server"]})
  private dashboard_preferences!: DashboardPreference | null;

  @Expose({groups: ['client']})
  public get dashboardPreferences() {
    return this.dashboard_preferences
  }

  public set dashboardPreferences(value) {
    this.dashboard_preferences = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use sendMessageOnEnter
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private send_message_on_enter!: boolean;

  @Expose({groups: ['client']})
  public get sendMessageOnEnter() {
    return this.send_message_on_enter
  }

  public set sendMessageOnEnter(value) {
    this.send_message_on_enter = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use loggedInAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private logged_in_at!: string | null;

  @Expose({groups: ['client']})
  public get loggedInAt() {
    return this.logged_in_at
  }

  public set loggedInAt(value) {
    this.logged_in_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use deletedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private deleted_at!: string | null;

  @Expose({groups: ['client']})
  public get deletedAt() {
    return this.deleted_at
  }

  public set deletedAt(value) {
    this.deleted_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isArchived
   * @default false
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  @Transform(({ obj }) => !!obj.deleted_at)
  private is_archived!: boolean;

  @Expose({groups: ['client']})
  public get isArchived() {
    return this.is_archived
  }

  public set isArchived(value) {
    this.is_archived = value
  }
}
export type User = Omit<__User, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'job_title' | 'saml_uid' | 'is_billable' | 'is_mfa_enabled' | 'user_groups' | 'forbidden_abilities' | 'language_preferences' | 'dashboard_preferences' | 'send_message_on_enter' | 'created_at' | 'updated_at' | 'logged_in_at' | 'deleted_at' | 'is_archived'>
export const User = __User as any as Constructor<User>
